/* eslint-disable */
export const getColor = (code) => {
  const mask = 255;
  const r = code & mask;
  const g = (code >> 8) & mask;
  const b = (code >> 16) & mask;

  return { r, g, b };
};

export const getColorString = (code) => {
  const rgb = getColor(code);
  return `rgb(${rgb.r},${rgb.g},${rgb.b})`;
};
